import React, { useState, useContext, memo, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from "@react-google-maps/api";
import { LocationContext } from "../services/LocationContext";
import logger from "../services/Logger";

const CommuteStatus = {
  IN_MAX_COMMUTE: 1,
  IN_MAX_COMMUTE_DIVIATION: 2,
  OUTSIDE_OF_MAX_COMMUTE: 3,
  CONSTRAINT: 4,
};

const MapComponent = memo(({ locationInfo, locations, apiKey }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: apiKey,
  });

  if (isLoaded) {
  }

  const [locationCommuate, setLocationCommute] = useState(new Map());
  const [selectedPlace, setSelectedPlace] = useState(null);

  const { setLocationCommuteResultValue, getLocationCommuteResultValue } = useContext(LocationContext);

  useEffect(() => {
    logger.debug("In map with highlights use effect");
    setLocationCommuteResultValue(locationCommuate);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationCommuate]);

  //   console.log("e are the parameters passed in - ", locationInfo);
  let mapCenter = { lat: 0, lng: 0 }; // Set initial map center
  if (!locationInfo) locationInfo = [];
  if (!locations) locations = [];
  if (locations.length > 0) {
    const bounds = new window.google.maps.LatLngBounds();
    locationInfo.forEach((location) => {
      bounds.extend(location.latLng);
    });
    mapCenter = bounds.getCenter();
  }

  const findLocationConstraint = (location) => {
    const existingResult = getLocationCommuteResultValue(location.locationAddress);
    if (existingResult) return existingResult;
    let locationCommuteStatus = 0;
    locations.forEach((locationConstraint) => {
      if (locationConstraint.commuteResult.inMaxCommute.find((obj) => obj.location === location.placeId)) {
        if (locationCommuteStatus < CommuteStatus.IN_MAX_COMMUTE) {
          locationCommuteStatus = CommuteStatus.IN_MAX_COMMUTE;
        }
      } else if (locationConstraint.commuteResult.inMaxCommuteDiviation.find((obj) => obj.location === location.placeId)) {
        if (locationCommuteStatus < CommuteStatus.IN_MAX_COMMUTE_DIVIATION) {
          locationCommuteStatus = CommuteStatus.IN_MAX_COMMUTE_DIVIATION;
        }
      } else if (locationConstraint.commuteResult.outsideOfMaxCommute.find((obj) => obj.location === location.placeId)) {
        if (locationCommuteStatus < CommuteStatus.OUTSIDE_OF_MAX_COMMUTE) {
          locationCommuteStatus = CommuteStatus.OUTSIDE_OF_MAX_COMMUTE;
        }
      } else {
        locationCommuteStatus = CommuteStatus.CONSTRAINT;
      }
    });
    ///TODO - move to map

    var returnObject = { fontSize: "16px", fontWeight: "bold" };
    if (locationCommuteStatus === CommuteStatus.IN_MAX_COMMUTE) {
      returnObject.text = "I";
      returnObject.color = "green";
    } else if (locationCommuteStatus === CommuteStatus.IN_MAX_COMMUTE_DIVIATION) {
      returnObject.text = "D";
      returnObject.color = "orange";
    } else if (locationCommuteStatus === CommuteStatus.OUTSIDE_OF_MAX_COMMUTE) {
      returnObject.text = "O";
      returnObject.color = "purple";
    } else if (locationCommuteStatus === CommuteStatus.CONSTRAINT) {
      returnObject.text = "C";
      returnObject.color = "blue";
    }

    setLocationCommute(new Map(locationCommuate.set(location.locationAddress, returnObject)));

    return returnObject;
  };

  return isLoaded ? (
    <GoogleMap mapContainerStyle={{ width: "100%", height: "400px" }} center={mapCenter} zoom={locationInfo.length > 0 ? 10 : 2}>
      {locationInfo.map((location, index) => (
        <Marker
          key={index}
          position={location.latLng}
          label={findLocationConstraint(location)}
          onMouseOver={() => setSelectedPlace(location)}
          onMouseOut={() => setSelectedPlace(null)}
        >
          {selectedPlace === location && (
            <InfoWindow position={location.latLng} onCloseClick={() => setSelectedPlace(null)}>
              <div>
                <p>{location.locationAddress}</p>
                {/* <p>{location.latLng}</p> */}
                {/* <p>{getLocationListingId(location)}</p> */}
              </div>
            </InfoWindow>
          )}
        </Marker>
      ))}
    </GoogleMap>
  ) : (
    <h2>Loading...</h2>
  );
});

export default MapComponent;
